import { has } from 'lodash';
import { useCallback, useEffect, useMemo } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

import { useAuthUser } from 'auth/hooks';
import { goTo } from 'core/utils';
import { routeVersionedMappings } from 'router/constants';
import { VersionViewType } from 'user/enums';

export const VersionedRoute = ({ path, element }) => {
  const params = useParams();

  const { user, isFetched } = useAuthUser();

  const [searchParams] = useSearchParams();

  const versionViewType = useMemo(
    () => user?.settings?.defaultVersionViewType,
    [user?.settings?.defaultVersionViewType]
  );

  const getOldVersionUrl = useCallback(
    (newVersionPath: string) => {
      if (has(routeVersionedMappings, newVersionPath)) {
        return routeVersionedMappings[newVersionPath](
          Object.values(params).join(', '),
          searchParams.get('trigger')
        );
      }

      return null;
    },
    [params, searchParams]
  );

  useEffect(() => {
    if (VersionViewType.PARTFINITI === versionViewType && isFetched) {
      const oldVersionPath = getOldVersionUrl(path);

      if (oldVersionPath) {
        goTo(oldVersionPath);
      }
    }
  }, [versionViewType, path, isFetched, getOldVersionUrl]);

  return element;
};
